import {cn} from 'platform/shared-tw';

import {PartSvg, type PartMode} from '../shared/PartSvg';
import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface FrontRightDoorProps {
  readonly mode?: PartMode;
  readonly variant?: DiagramVariant;
  readonly onClick?: () => void;
}

export function FrontRightDoor(props: FrontRightDoorProps) {
  return (
    <PartSvg
      mode={props.mode}
      onClick={props.onClick}
      label="Front Right Door"
      width={330}
      height={115}
      viewBox="0 0 330 115"
      position={{top: -28, left: 409}}
    >
      {/* Door body + glass (evenodd composite) */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M328 114L309 62.3048C309.333 60.1916 309 54.233 305 47.3048C301 40.3766 297.333 32.1134 296 29.0001H1C1 35.9753 6.18307 54.4223 26 61.0001C27.7022 61.5651 30 62.0001 33 63.0001C54 70.0001 177.033 106 233 110C257.055 111.719 281.035 113.732 298 114H328ZM308.704 108C219.704 108 186 98.0001 135 85.0001C119.545 81.0605 105 77.0001 97 73.0001C93.0738 71.037 87.0339 66.0283 82.042 61.0421C140.06 60.4895 232.001 62.0001 283 62.0001C293.406 80.0379 299.615 91.44 308.704 108Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      {/* Door glass overlay */}
      <path
        opacity="0.8"
        d="M308.704 108C299.614 91.44 293.406 80.0379 283 62.0001C232 62.0001 140.059 60.489 82.0416 61.0417C87.0336 66.028 93.0736 71.0369 97 73.0001C105 77.0001 119.545 81.0605 135 85.0001C186 98.0001 219.704 108 308.704 108Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      {/* Outer stroke */}
      <path
        d="M233 110C177.033 106 54 70.0001 33 63.0001C30 62.0001 27.7022 61.5651 26 61.0001C6.18307 54.4223 1 35.9757 1 29.0006L296 29.0001C297.333 32.1134 301 40.3766 305 47.3048C309 54.233 309.333 60.1916 309 62.3048L328 114H298C281.035 113.732 257.055 111.719 233 110Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      {/* Pillar line */}
      <path
        d="M283 62.0001C294.616 82.1338 301 94.0001 312 114"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      {/* Glass inner line */}
      <path
        d="M82 61.0001C87 66.0001 93.0627 71.0315 97 73.0001C105 77.0001 119.545 81.0605 135 85.0001C186 98.0001 220 108 309 108"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      {/* Waist line */}
      <path
        d="M33 63.0001C58 59.0001 211.141 62.0001 283 62.0001H309"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      {/* Belt line */}
      <path
        d="M9 48.5217C86.604 49.0381 194.989 49.3595 307 50.6087L9 48.5217Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      {/* Mirror body fill */}
      <path
        d="M33 63.0001C40.3544 61.8234 58.7983 61.2198 83 61.0001L82.2148 60.2052C80.3359 58.2582 78.2682 55.6475 79.9795 53.0333C86.4304 54.0118 93.1867 54.2967 97.2373 53.6613C103.669 52.6522 111.308 4.85698 108.34 2.83899C105.371 0.820972 95.2576 -2.84077 79.4258 13.3019C74.0279 18.8058 69.8557 24.2013 67.0664 29.1241L67 29.0001C65.1795 32.2954 60 41.4001 56 47.0001C52 52.6001 39 60.0001 33 63.0001Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      {/* Mirror outline */}
      <path
        d="M79.4258 13.3023C95.2582 -2.8411 105.372 0.821266 108.34 2.83925C111.309 4.85724 103.669 52.6518 97.2373 53.6609C90.8053 54.6699 77.5511 53.3601 69.5305 50.634C57.6562 46.5981 62.5747 30.4844 79.4258 13.3023Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      {/* Mirror inner line */}
      <path
        d="M91 54.0001C96 49.0001 104 20.0001 104 2.00012"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      {/* Mirror arm */}
      <path
        d="M67 29.0001C65.1795 32.2954 60 41.4001 56 47.0001C52 52.6001 39 60.0001 33 63.0001C40.3544 61.8234 58.7983 61.2198 83 61.0001C81 59.0001 78 56.0001 80 53.0001"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      {/* Door handle fill */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M245 39.0001C259.937 38.9999 279.853 37.0001 277.861 34.0001C271.119 23.8439 252.966 24.0001 245 24.0001C237.034 24.0001 218.881 23.8439 212.139 34.0001C210.147 37.0001 230.062 38.9999 245 39.0001ZM228 33.0001C229.766 30.757 232.491 29.0002 237 29.0001H253C257.509 29.0002 260.234 30.7569 262 33.0001H228Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      {/* Handle outline */}
      <path
        d="M277.862 34.0002C271.119 23.8438 252.966 24.0003 245 24.0003C237.034 24.0003 218.881 23.8438 212.138 34.0002C210.147 37.0001 230.062 38.9999 245 39.0001C259.937 38.9999 279.853 37.0001 277.862 34.0002Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      {/* Handle inner */}
      <path
        d="M264 38.0001C263.667 35.3335 261 29.0001 253 29.0001C245 29.0001 245 29.0001 245 29.0001C245 29.0001 245 29.0001 237 29.0001C229 29.0001 226.333 35.3335 226 38.0001"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M228 33.0001H262"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
    </PartSvg>
  );
}
